import { Component, OnInit } from '@angular/core';
import { OptionService } from '../../shared/option.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectService } from '../project.service';
import { Project } from '../../models/project';
import { AlertService } from '../../core/alert.service';
import { ModalComponent } from '../../core/modal.component';
import { ActiveModal } from '../../core/modal.service';

@Component({
  selector: 'cw-change-status-modal',
  templateUrl: './change-status-modal.component.html',
  styleUrls: ['./change-status-modal.component.css']
})
export class ChangeStatusModalComponent extends ModalComponent implements OnInit {
  form: FormGroup;
  isSaving: boolean;
  projects: Project[];
  statusOptions: { value: string; label: any }[];

  constructor(private projectService: ProjectService,
              private optionService: OptionService,
              private alert: AlertService,
              public modal: ActiveModal,
              private fb: FormBuilder) {
    super(modal);
    this.createForm();
  }

  ngOnInit() {
    this.statusOptions = this.optionService.projectStatusOptions;
    this.opened = true;
  }

  save() {
    this.isSaving = true;
    const status = this.form.get('status').value;
    this.projectService.updateStatusMany(this.projects, status)
      .finally(() => this.isSaving = false)
      .subscribe(ok => {
          this.alert.success('Projekt uppdaterade!');
          this.modal.close(true);
        },
        err => {
        });
  }

  private createForm() {
    this.form = this.fb.group({
      status: [null, Validators.required]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/change-status-modal/change-status-modal.component.ts